import axios from 'axios'
import store from '../index'
import JwtDecode from 'jwt-decode'
import Moment from 'moment'

const KEY_TOKEN = 'apollo-token'

export function isTokenExpiredOrInvalid (token) {
  try {
    const decoded = JwtDecode(token)

    if (!decoded) return false

    return Moment(decoded.exp * 1000).isBefore(new Date())
  } catch (error) {
    console.error(error)

    return true
  }
}

const state = {
  isLoggedIn: false
}

const mutations = {
  logout (state) {
    axios.defaults.headers['Authorization'] = null

    window.localStorage.removeItem(KEY_TOKEN)

    state.isLoggedIn = false
  },

  checkToken (state) {
    if (isTokenExpiredOrInvalid(window.localStorage.getItem(KEY_TOKEN))) {
      store.commit('auth/logout')

      window.location.reload()
    }
  }
}

const actions = {
  async checkStorage (context) {
    const token = window.localStorage.getItem(KEY_TOKEN)

    if (token) {
      context.state.isLoggedIn = true
    }

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        store.commit('auth/checkToken')
      }
    })
  },

  async login (context, { email, password }) {
    const response = await axios.post('/auth/login', {
      email,
      password
    })

    window.localStorage.setItem(KEY_TOKEN, response.data.token)

    return response.data.user
  },

  async forgot (context, { email }) {
    await axios.post('/auth/forgot-password', {
      email
    })
  },

  async resetPassword (context, { token, password }) {
    await axios.post('/auth/reset-password', {
      token,
      password
    })
  },

  async resendVerification (context, { email }) {
    await axios.post('/auth/resend-verification', {
      email
    })
  },

  async verifyAccount (context, { token, password }) {
    await axios.post('/auth/verify', {
      token,
      password
    })
  },

  async masquerade (context, { token }) {
    const response = await axios.post('/auth/masquerade', {
      token
    })

    window.localStorage.setItem(KEY_TOKEN, response.data.token)
  }
}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
